import apiClient from './apiClient';

export async function listPending(filters = {}) {
  const res = await apiClient.get('/order-analysis/pending', { params: filters });
  return res.data.data.items;
}

export async function getBreakdown(dimension) {
  const res = await apiClient.get('/order-analysis/breakdown', { params: { dimension } });
  return res.data.data.items;
}

export async function getDesignOptions() {
  const res = await apiClient.get('/order-analysis/design-options');
  return res.data.data.items;
}

export async function getCompleteOrders() {
  const res = await apiClient.get('/order-analysis/complete-orders');
  return res.data.data.items;
}

export async function getPendingOrderGroups() {
  const res = await apiClient.get('/order-analysis/pending-order-groups');
  return res.data.data.items;
}

export async function getInactiveCustomers(thresholdDays) {
  const res = await apiClient.get('/order-analysis/inactive-customers', { params: { threshold: thresholdDays } });
  return res.data.data.items;
}

export async function getCompletePartyCount() {
  const res = await apiClient.get('/order-analysis/complete-party-count');
  return res.data.data.count;
}

export async function getSizeOptions() {
  const res = await apiClient.get('/order-analysis/size-options');
  return res.data.data.items;
}

export async function getTrend(designId, weeks = 12) {
  const res = await apiClient.get('/order-analysis/trend', { params: { designId, weeks } });
  return res.data.data.items;
}

export async function refreshOrderAnalysis() {
  const res = await apiClient.post('/order-analysis/refresh');
  return res.data.data;
}
